export default "<iframe [src]=\"url\" width=\"100%\" height=\"100%\">\r\n</iframe>\r\n"